import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Flare, MenuOutlined } from "@mui/icons-material";
import { useHistory } from "react-router";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";

export default function SwipeableTemporaryDrawer() {
  const history = useHistory();
  let dir = "right";
  const link2 = [
    {
      name: "HOME",
      link: "#home",
    },
    {
      name: "TOKENOMICS",
      link: "#tokonomics",
    },
    {
      name: "ROADMAP",
      link: "#roadMap",
    },
    {
      name: "TEAM",
      link: "#ourTeam",
    },
    {
      name: "Use Cases",
      link: "#useCase",
    },
    {
      name: "MEDIA",
      link: "#media",
    },
    {
      name: "Partnership",
      link: "#partner",
    },
    {
      name: "Whitepaper",
      link: "/whitepaper.pdf",
    },
    {
      name: "SOLAR",
      link: "https://solscan.io/token/2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g",
    },
  ];

  const [state, setState] = React.useState({
    right: false,
  });
  const toggleDrawer = (open) => () => {
    setState({ [dir]: open });
  };

  return (
    <>
      <Box display="flex" alignItems="center">
        <MenuOutlined
          sx={{
            color: "white",
            fontSize: "35px",
            "&:hover": { cursor: "pointer" },
          }}
          onClick={toggleDrawer(dir, true)}
        />
        {/* <WalletMultiButton style={{ marginLeft: '16px' }} /> */}
      </Box>

      <SwipeableDrawer
        anchor={dir}
        open={state[dir]}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        // id="color-id"
        id="dcode"
        // style={{backgroundColor:'red', background:'red'}}
      >
        <Box
          sx={{ width: 250, marginLeft: "5vw", marginTop: "2vh" }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            {link2.map((obj, index) => (
              <ListItem>
                <ListItemIcon>
                  {" "}
                  <Flare sx={{ color: "white" }} />{" "}
                </ListItemIcon>
                <a
                  href={obj.link}
                  style={{
                    color: "white",
                    textDecoration: "none",
                    textTransform: "uppercase",
                  }}
                >
                  <ListItemText
                    primary={obj.name}
                    onClick={() => {
                      history.push("/");
                    }}
                  />
                </a>
              </ListItem>
            ))}
            <ListItem>
              <ListItemIcon>
                {" "}
                <Flare sx={{ color: "white" }} />{" "}
              </ListItemIcon>
              <a
                href="#/"
                onClick={() => {
                  history.push("/preSale");
                }}
                style={{ color: "white", textDecoration: "none" }}
              >
                <ListItemText>
                  {" "}
                  <center>
                    <span
                      style={{
                        padding: "10px 14px",
                        width: "120px",
                        height: "20px",
                        fontSize: "16px",
                        fontWeight: "bolder",
                      }}
                      className="glow-on-hover"
                    >
                      Solar PreSale
                    </span>
                  </center>{" "}
                </ListItemText>
              </a>
            </ListItem>
            {/* <ListItem>
              <WalletMultiButton style={{ marginLeft: '16px' }} />
            </ListItem> */}
          </List>
        </Box>
      </SwipeableDrawer>
    </>
  );
}
